export const colors = {
  primary: "#144677", // Navy blue
  secondary: "#1a5c99", 
  accent: "#FF6266",
  white: "#FFFFFF",
  gray: "#f3f4f6",
  darkGray: "#6b7280",
  error: "#ef4444",
  info: "#3B82F6",
  success: "#10B981",
  warning: "#F59E0B",
  mutedBlue: "#27496d",
  lightAccent: "#FFA69E",
};
